import { render, staticRenderFns } from "./skintemperature.vue?vue&type=template&id=dc4e83de"
import script from "./skintemperature.vue?vue&type=script&lang=js"
export * from "./skintemperature.vue?vue&type=script&lang=js"
import style0 from "./skintemperature.vue?vue&type=style&index=0&id=dc4e83de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports